import React, { Fragment, useEffect, useContext } from 'react';
import Spinner from '../layout/Spinner';
import Repos from '../repos/Repos';
import { Link } from 'react-router-dom';
import GithubContext from '../../context/github/githubContext';

const User = ({ match }) => {
  const githubContext = useContext(GithubContext);

  const { loading, user, getUser, getUserRepos, repos } = githubContext;

  useEffect(() => {
    getUser(match.params.login);
    getUserRepos(match.params.login);
    // eslint-disable-next-line
  }, []);

  const {
    name,
    avatar_url,
    location,
    bio,
    blog,
    login,
    html_url,
    followers,
    following,
    public_repos,
    public_gists,
    company,
    hireable
  } = user;
  if (loading) return <Spinner />;
  return (
    <div className='container profile'>
      <div className='row'>
        <div className='col-lg-4 col-md-12'>
          <div className='row all-center'>
            <h5>
              Hireable:{' '}
              {hireable ? (
                <i className='fas fa-check' style={hireableStyle} />
              ) : (
                <i className='fas fa-times-circle' style={hireableStyle} />
              )}
            </h5>
            <Link to='/search' className='btn btn-dark btn-block'>
              Back To Search
            </Link>
          </div>
          <div className='row'>
            <div className='card' style={cardStyle}>
              <div>
                <img
                  src={avatar_url}
                  alt=''
                  className='img-fluid rounded-circle w-50 mb-3 all-center'
                />
              </div>
              <h1 className='head-title'>{name}</h1>
              {location ? (
                <h3>Location: {location}</h3>
              ) : (
                <h3>Location: N/M</h3>
              )}
              <p>
                <a href={html_url} className='btn btn my-btn'>
                  Visit Github Profile
                </a>
              </p>
            </div>
            <div className='container row' style={infoUerStyle}>
              <div className='col-12'>
                <p style={headerStyle}>
                  {login && (
                    <Fragment>
                      <b>Username: </b> <p>{login}</p>
                    </Fragment>
                  )}
                </p>
              </div>
              <div className='col-12'>
                <p style={headerStyle}>
                  {company && (
                    <Fragment>
                      <b>Company: </b> <p>{company}</p>
                    </Fragment>
                  )}
                </p>
              </div>
              <div className='col-12'>
                <p style={headerStyle}>
                  {blog && (
                    <Fragment>
                      <b>Website: </b> <p>{blog}</p>
                    </Fragment>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-8 col-md-12'>
          <div className='container row profile-static'>
            <div className='col-3 all-center'>
              <h1>Followers</h1>
              <h2>{followers}</h2>
            </div>
            <div className='col-3 all-center'>
              <h1>Following</h1>
              <h2>{following}</h2>
            </div>
            <div className='col-3 all-center'>
              <h1>Repos</h1>
              <h2>{public_repos}</h2>
            </div>
            <div className='col-3 all-center'>
              <h1>Gists</h1>
              <h2>{public_gists}</h2>
            </div>
            {bio && (
              <div className='row'>
                <div className='explore-bio-profile'>
                  <div className='container'>
                    <div class='col all-center py-5'>
                      <h3>Bio</h3>
                      <p> {bio} </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Repos repos={repos} />
        </div>
      </div>
    </div>
  );
};

const hireableStyle = {
  marginLeft: '5px',
  fontSize: '16px',
  color: '#cd5c5c'
};

const cardStyle = {
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
  marginTop: '20px',
  backgroundColor: 'white',
  borderRadius: 'none',
  textAlign: 'center',
  paddingBottom: '15px',
  minHeight: '350px'
};

const infoUerStyle = {
  marginTop: '25px'
};

const headerStyle = {
  marginTop: '10px'
};

export default User;
